import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  pageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    paddingTop: '12px',
    backgroundColor: palette.shades[100],
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  pageHeader: {
    flexShrink: 0,
    padding: '4px 16px 12px'
  },
  headerWrapper: {
    flexShrink: 0,
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  headerTabs: {
    padding: '0 12px'
    // borderBottom: `1px solid ${palette.shades[300]}`,
  },
  headerFilters: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '65px'
  },
  contentWrapper: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  // Subscriptions tab: full height, scroll inside table
  subscriptionsRoot: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  subscriptionsToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    padding: '16px',
    flexShrink: 0,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '& .MuiTextField-root': {
      minWidth: 320
    },
    '& .MuiButton-root path': {
      fill: palette.shades[100]
    },
    '& > div:first-of-type > div > div:first-of-type': {
      top: 5,
      left: 8
    },
    '& .MuiChip-root': {
      padding: '8px',
      '& svg': {
        marginRight: '4px'
      }
    }
  },
  subscriptionsToolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    minWidth: 0
  },
  subscriptionsTablePaper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    border: 'none',
    borderRadius: 0,
    '& .MuiTableCell-root': {
      fontSize: 14,
      verticalAlign: 'top'
    },
    '& .MuiTableRow-root .MuiTableCell-root:first-of-type': {
      paddingLeft: 4,
      paddingRight: 4
    },
    '& .MuiTableHead-root .MuiTableCell-root:first-of-type': {
      paddingTop: 8
    },
    '& .MuiTableBody-root .MuiTableCell-root:first-of-type': {
      paddingTop: 10
    }
  },
  subscriptionsTableContainer: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0,
    WebkitOverflowScrolling: 'touch'
  },
  subscriptionsTable: {
    minWidth: 2040
  },
  billsFileNameCell: {
    minWidth: 200,
    maxWidth: 260
  },
  billsFileNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    overflow: 'hidden'
  },
  /** th/td: force single-line cell content (Typography noWrap alone is not enough in tables) */
  billsCellNoWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    verticalAlign: 'middle'
  },
  billsUtilitiesCell: {
    whiteSpace: 'nowrap'
  },
  billsUtilitiesIcons: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'nowrap',
    '& svg': {
      display: 'block',
      flexShrink: 0
    }
  },
  billsPropertiesCell: {
    minWidth: 220,
    maxWidth: 320
  },
  billsTableChip: {
    fontSize: 13,
    maxWidth: '100%',
    '& .MuiChip-label': {
      fontSize: 13,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  subscriptionsStickyCheckboxHead: {
    position: 'sticky',
    left: 0,
    zIndex: 5,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  subscriptionsStickyCheckbox: {
    position: 'sticky',
    left: 0,
    zIndex: 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderRight: "1px solid ".concat(palette.shades[300])
  },
  subscriptionsStickyActionsHead: {
    position: 'sticky',
    right: 0,
    zIndex: 5,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300])
  },
  subscriptionsStickyActions: {
    position: 'sticky',
    right: 0,
    zIndex: 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300])
  },
  subscriptionsTableEmpty: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tableHeadCell: {
    fontWeight: 600,
    backgroundColor: '#FFFFFF',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    whiteSpace: 'nowrap'
  },
  tableBodyRow: {
    '& .MuiTableCell-root': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    }
  },
  billsClickableRow: {
    cursor: 'pointer'
  },
  pricingsCell: {
    verticalAlign: 'top',
    paddingTop: 8,
    paddingBottom: 8
  },
  pricingsStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    paddingRight: '24px'
  },
  pricingCard: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    padding: '8px 10px',
    backgroundColor: '#f8f9fa'
  },
  pricingCardContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8
  },
  pricingAmount: {
    whiteSpace: 'nowrap',
    marginLeft: 'auto'
  },
  actionsCell: {
    verticalAlign: 'top',
    paddingTop: 8,
    paddingBottom: 8,
    minWidth: 68,
    width: 68,
    whiteSpace: 'nowrap'
  },
  tablePagination: {
    flexShrink: 0,
    borderTop: "1px solid ".concat(palette.shades[300])
  },
  selectionBar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 24px',
    minHeight: 56,
    backgroundColor: palette.shades[100],
    borderTop: "1px solid ".concat(palette.shades[300]),
    zIndex: 1100,
    boxShadow: 'none'
  },
  selectionBarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  selectionBarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    '& svg path': {
      fill: palette.shades[100]
    }
  },
  // Pricings tab: select all bar and scroll area
  pricingsSelectAllBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 10px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    backgroundColor: '#fff',
    flexShrink: 0
  },
  pricingsSelectAllCheckbox: {
    padding: 4
  },
  pricingsSelectAllLabel: {
    userSelect: 'none'
  },
  pricingsScrollWrapper: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto'
  },
  pricingsEmpty: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  pricingsRecord: {
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  pricingsRecordHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 0,
    backgroundColor: '#f3f7fa',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    padding: '12px 16px',
    fontWeight: 600,
    fontSize: 15,
    justifyContent: 'space-between'
  },
  pricingsRecordHeaderLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  pricingsRecordHeaderRight: {
    display: 'flex',
    alignItems: 'center'
  },
  pricingsRecordHeaderExpand: {
    padding: 4,
    marginRight: 4
  },
  pricingsRecordHeaderTitle: {
    marginRight: 8
  },
  pricingsRecordHeaderDivider: {
    width: 1,
    height: 20,
    backgroundColor: palette.shades[300],
    margin: '0 12px',
    flexShrink: 0
  },
  pricingsRecordHeaderCount: {
    fontWeight: 500,
    fontSize: 14,
    color: palette.shades[700]
  },
  pricingsRecordHeaderAdd: {
    marginLeft: 0,
    padding: 4
  },
  pricingsRecordContent: {
    padding: 0,
    backgroundColor: '#FFFFFF'
  },
  pricingsContentRow: {
    display: 'flex',
    alignItems: 'stretch',
    padding: '4px 10px',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    gap: 12,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  pricingsContentRowCheckbox: {
    padding: 4,
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowName: {
    minWidth: 0,
    alignSelf: 'center'
  },
  pricingsContentRowChip: {
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 11,
    height: 20,
    '& .MuiChip-label': {
      fontSize: 12
    }
  },
  pricingsContentRowSubs: {
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowDivider: {
    width: 1,
    height: 20,
    backgroundColor: palette.shades[300],
    margin: '0 2px',
    flexShrink: 0,
    alignSelf: 'center'
  },
  pricingsContentRowSpacer: {
    flex: '1 1 auto',
    minWidth: 0
  },
  pricingsContentRowPrices: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 0,
    flexShrink: 0,
    marginRight: 8,
    alignSelf: 'stretch'
  },
  pricingsPriceBlock: {
    minWidth: 70,
    marginLeft: -1,
    padding: '8px 10px',
    backgroundColor: 'transparent',
    border: 'none',
    borderLeft: "1px solid ".concat(palette.shades[300]),
    borderRight: "1px solid ".concat(palette.shades[300]),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 4
  },
  pricingsPriceBlockTitle: {
    fontSize: 12,
    lineHeight: 1.2
  },
  pricingsPriceBlockAmount: {
    fontSize: 14,
    lineHeight: 1.2
  },
  pricingsContentRowActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 0,
    flexShrink: 0,
    alignSelf: 'center',
    '& .MuiIconButton-root': {
      padding: 4
    },
    '& svg': {
      padding: 2
    }
  },
  pricingsDeleteButtonDefault: {
    opacity: 0.5
  },
  bulkDeleteConfirmBody: {
    padding: 24
  },
  bulkDeleteConfirmTitle: {
    marginBottom: 8
  }
}));
export default useStyles;